import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSvgIcon',
  props: {
    name: {}
  },
  setup(__props: any) {

const props = __props;



const dynamicComponent = computed((): [ReturnType<typeof defineAsyncComponent>] => defineAsyncComponent(() => import(`@/assets/svg/${props.name}.vue`)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(dynamicComponent.value), { class: "svg-icon" }))
}
}

})